import React, { useState, useContext } from 'react';
import { motion } from 'framer-motion';
import { UserContext } from '../../../context/UserContext';
import { SystemError } from '../../error/SystemError';
import { dismissModal } from '../../../service/modal-service';
import { LoadingCover } from '../../commons/LoadingCover';
import { editPostPrivacy } from '../../../api/post/buzz-api';
import BottomSheet from '../../commons/BottomSheet';
import { Shield, Globe, Users, Check } from 'lucide-react';

export const BuzzPrivacy = (props) => {
    const refreshBuzz = props.refreshBuzz
    const editEntityId = props.editEntityId

    const [isOpen, setIsOpen] = useState(true)
    const [postSecurity, setPostSecurity] = useState(props.postSecurity)
    const [isLoading, setIsLoading] = useState(false)
    const [isSystemError, setIsSystemError] = useState(false)
    const [errorContent, setErrorContent] = useState({'header': "", 'body': ""})
    
    const { userId } = useContext(UserContext)

    const handleClose = () => {
        dismissModal()
    }

    const privacyOptions = [
        { value: 'public', label: 'Everyone', description: 'Anyone can see this post', icon: Globe },
        { value: 'strings', label: 'Connections Only', description: 'Only your connections can see', icon: Users },
    ]

    const editPrivacy = async(value) => {
        setPostSecurity(value)
        setIsLoading(true)
        try {
            await editPostPrivacy(editEntityId, userId, value)
            setIsLoading(false)
            refreshBuzz()
        } catch (error) {
            console.log(error)
            setErrorContent({ 'header': "Error updating privacy", 'body': "Please try again. If problem persists, contact us at support@stringssg.com" })
            setIsSystemError(true)
            setIsLoading(false)
        }
    }

    return (
        <>
            <BottomSheet isOpen={isOpen} onClose={handleClose} maxWidth="md">
                <BottomSheet.Header>
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center">
                            <Shield className="w-5 h-5 text-orange-600" />
                        </div>
                        <BottomSheet.Title>Post Privacy</BottomSheet.Title>
                    </div>
                </BottomSheet.Header>

                <BottomSheet.Content>
                    <div className="space-y-4">
                        <p className="text-sm text-gray-500">Who can see this post?</p>
                        <div className="space-y-2">
                            {privacyOptions.map((option) => {
                                const Icon = option.icon
                                const isSelected = postSecurity === option.value
                                return (
                                    <motion.button
                                        key={option.value}
                                        whileTap={{ scale: 0.98 }}
                                        onClick={() => editPrivacy(option.value)}
                                        className={`w-full flex items-center gap-3 p-4 rounded-xl border-2 transition-all ${
                                            isSelected 
                                                ? 'border-orange-500 bg-orange-50' 
                                                : 'border-gray-100 hover:border-gray-200 hover:bg-gray-50'
                                        }`}
                                    >
                                        <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                                            isSelected ? 'bg-orange-500 text-white' : 'bg-gray-100 text-gray-500'
                                        }`}>
                                            <Icon className="w-4 h-4" />
                                        </div>
                                        <div className="flex-1 text-left">
                                            <p className={`font-medium ${isSelected ? 'text-orange-600' : 'text-gray-900'}`}>
                                                {option.label}
                                            </p>
                                            <p className="text-xs text-gray-500">{option.description}</p>
                                        </div>
                                        {isSelected && (
                                            <div className="w-6 h-6 rounded-full bg-orange-500 flex items-center justify-center">
                                                <Check className="w-3.5 h-3.5 text-white" />
                                            </div>
                                        )}
                                    </motion.button>
                                )
                            })}
                        </div>
                    </div>
                </BottomSheet.Content>

                <BottomSheet.Footer>
                    <BottomSheet.CloseButton variant="primary" className="w-full">Done</BottomSheet.CloseButton>
                </BottomSheet.Footer>
            </BottomSheet>

            {isLoading && <LoadingCover />}
            {isSystemError && <SystemError errorContent={errorContent} setIsSystemError={setIsSystemError} />}
        </>
    )
}
